import { VERSION } from "@fathom/core";

export const INTAKE_VERSION = VERSION;

export * from "./types.js";
export {
  extractWorkItems,
  createExtractor,
  parseExtractionResponse,
  EXTRACTION_SYSTEM_PROMPT,
} from "./extractor.js";
export type { ExtractorOptions, GenerateFunction } from "./extractor.js";
export { enrichSlices } from "./enricher.js";
export { formatAsMarkdown, formatSliceTable } from "./formatter.js";
